namespace GeniuzPOS.Purchase {
    export class PoCreditNoteDtColumns {
        static columnsKey = 'Purchase.PoCreditNoteDt';
    }
}
